import { GlobalExclusionsAppController } from '../controller/GlobalExclusionsAppController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { ExclusionListItem } from '../../exclusionsPanel/types';

export class GlobalExclusionsAppWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: GlobalExclusionsAppController,
    });
  }

  private observablePropertyHandler = {
    "data-company-id": this.companyIdChanged.bind(this),
    "data-active-exclusion-list": this.activeExclusionListChanged.bind(this),
  };

  static override get observedAttributes(): string[] {
    return [...BaseWebComponentElement.observedAttributes, "data-company-id", 'data-active-exclusion-list'];
  }

  override attributeChangedCallback(name: string, oldValue: string, newValue: string): void {
    if (this.observablePropertyHandler[name]) {
      this.observablePropertyHandler[name](oldValue, newValue);
    } else if (GlobalExclusionsAppWebComponent.observedAttributes.indexOf(name) !== -1) {
      (this.controller as GlobalExclusionsAppController)?.render().then().catch();
    }
  }

  private companyIdChanged() {
    this.activeExclusionList = {label: '', value: ''};
  }

  private activeExclusionListChanged() {
    (this.controller as GlobalExclusionsAppController)?.showExclusionsGrid();
  }

  get activeExclusionList(): ExclusionListItem {
    return this.getValueFromAttribute(this, 'data-active-exclusion-list', {});
  }

  set activeExclusionList(value: ExclusionListItem) {
    this.setAttribute('data-active-exclusion-list', JSON.stringify(value));
  }
}
